import React, { PropsWithChildren } from 'react';
import LoadingSpinner from './LoadingSpinner';

function ApiData<T>(props: PropsWithChildren & { data: T; isLoading: boolean; isError: boolean }) {
  const { data, isLoading, isError, children } = props;
  if (!data || isLoading) {
    return <LoadingSpinner />;
  } else if (isError) {
    return <div>Error</div>;
  }
  return <>{children}</>;
}

export default ApiData;
